import { Box } from "@mui/material";
import { useContext } from "react";
import { AppContext } from "../common/AppContext";
import { useLocale } from "../providers/LocaleProvider";

const StandardLibraryCheck = ({ children }: { children: React.ReactNode }) => {
  const { organization } = useContext(AppContext);
  const { translate } = useLocale();

  if (!organization?.enableStandardsLibrary) {
    return (
      <Box
        dangerouslySetInnerHTML={{
          __html: translate("settings.contactToUnlock").replace(
            "<a>",
            '<a href="mailto:support@klayo.com">'
          )
        }}
      />
    );
  }

  return <>{children}</>;
};

export default StandardLibraryCheck;
